import { render, staticRenderFns } from "./mainlandorder-list.vue?vue&type=template&id=1b023d12"
import script from "./mainlandorder-list.vue?vue&type=script&lang=ts"
export * from "./mainlandorder-list.vue?vue&type=script&lang=ts"
import style0 from "./mainlandorder-list.vue?vue&type=style&index=0&id=1b023d12&prod&lang=css"
import style1 from "./mainlandorder-list.vue?vue&type=style&index=1&id=1b023d12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports